// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
// jQuery(function ($) {
//   // var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
//   var headerHeight = $("header").innerHeight(); // ヘッダー追従の場合 // if header following
//   $('a[href^="#"]').click(function () {
//     var href = $(this).attr("href");
//     var target = $(href == "#" || href == "" ? "html" : href);
//     if (target.length > 0) {
//       var position = target.offset().top - headerHeight;
//       $("html, body").animate({ scrollTop: position }, 550, "swing");
//       return false;
//     }
//   });
// });

jQuery(function ($) {
  $(window).on("load", function () {
    // ページのURLを取得
    const url = $(location).attr("href"),
      headerHeight = $("header").innerHeight() + 20;

    var parm = getUrlVars();

    // urlに「?sec」が含まれていれば
    if (parm["sec"]) {
      (target = $("#" + parm["sec"])), (position = Math.floor(target.offset().top) - headerHeight);
      // positionの位置に移動
      $("html, body").animate({ scrollTop: position }, 400, "swing");
    }
    if (parm["tab"]) {
      // //コンテンツ非表示&amp;タブを非アクティブ
      $(".facility .js_tabContent").hide();
      $(".facility .js_tabBtn button").removeClass("active");
      //何番目のタブかを格納
      var tabno = $(".facility .js_tabBtn li#" + parm["tab"]).index();
      // //コンテンツ表示
      $(".facility .js_tabContent").eq(tabno).fadeIn();
      //タブのアクティブ化
      $(".facility .js_tabBtn button").eq(tabno).addClass("active");
    }
  });
});

function getUrlVars() {
  var vars = [],
    hash,
    hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    if (hash.length > 1) {
      var _var = hash[1].replace(/#.+/, "");
      if (_var != "") {
        vars[hash[0]] = _var;
      } else {
        vars[hash[0]] = "Null";
      }
    }
  }
  return vars;
}

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
  if ($(".obj_image").length > 0) {
    objectFitImages(".obj_image");
  }
});

// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });

// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function ($) {
  if ($(".js-image-switch").length > 0) {
    var $elem = $(".js-image-switch");
    var sp = "_sp.";
    var pc = "_pc.";
    // 画像を切り替えるウィンドウサイズ // Window size to switch images
    var replaceWidth = 768;

    function imageSwitch() {
      var windowWidth = parseInt($(window).width());
      $elem.each(function () {
        var $this = $(this);
        if (windowWidth >= replaceWidth) {
          $this.attr("src", $this.attr("src").replace(sp, pc));
        } else {
          $this.attr("src", $this.attr("src").replace(pc, sp));
        }
      });
    }
    imageSwitch();

    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        imageSwitch();
      }, 200);
    });
  }
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($("dl.accordion dt").length > 0) {
    $("dl.accordion dt").click(function () {
      $(this).next("dd").slideToggle();
      $(this).toggleClass("open");
    });
  }
});

function getQuerySize() {
  if (window.matchMedia("(max-width: 768px)").matches) {
    return "sp";
  } else {
    return "pc";
  }
}

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }

  var windowWidth = $(window).width();
  var windowSm = 768;
  if (windowWidth <= windowSm) {
    if ($(".js_header_parent_trigger").length > 0) {
      $(".js_header_parent_trigger").on("click", function () {
        if ($(this).next().hasClass("open")) {
          $(".js_header_child.open").slideUp();
          $(".js_header_child.open").removeClass("open");
        } else {
          $(".js_header_child.open").slideUp();
          $(".js_header_child.open").removeClass("open");
          $(this).next().slideDown();
          $(this).next().addClass("open");
        }
      });
    }
  }
});

//Tab effect
jQuery(function ($) {
  $(".js_tabBase .js_tabBtn").on("click", "li", function () {
    var _target = $(this).index();
    $(".js_tabBase .js_tabBtn button").removeClass("active");
    $(this).children("button").addClass("active");

    $(".js_tabBase .js_tabContentArea")
      .children(".js_tabContent.active")
      .fadeOut(150, function () {
        $(".js_tabBase .js_tabContentArea").children(".js_tabContent").removeClass("active");
        $(".js_tabBase .js_tabContentArea")
          .children(".js_tabContent")
          .eq(_target)
          .fadeIn(300, function () {
            $(".js_tabBase .js_tabContentArea").children(".js_tabContent").eq(_target).addClass("active");
            return false;
          });
      });
  });
});

// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function ($) {
  if ($("#pageplugin").length > 0) {
    var windowWidth = $(window).width();
    var htmlStr = $("#pageplugin").html();
    var timer = null;
    $(window).on("resize", function () {
      var resizedWidth = $(window).width();
      if (windowWidth != resizedWidth && resizedWidth < 500) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          $("#pageplugin").html(htmlStr);
          window.FB.XFBML.parse();
          //window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
          var windowWidth = $(window).width();
        }, 500);
      }
    });
  }
});

//モーダル
jQuery(function ($) {
  $(".js-modal-open").each(function () {
    $(this).on("click", function () {
      var target = $(this).data("target");
      var modal = document.getElementById(target);
      $(modal).fadeIn();
      $("body").addClass("noscroll");
      return false;
    });
  });
  $(".js-modal-close").on("click", function () {
    $(".js-modal").fadeOut();
    $("body").removeClass("noscroll");
    return false;
  });
});

plantsArticleSwiper = new Swiper(".plants-swiper", {
  speed: 1000, // スライド変化時間
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

volunteerSwiper = new Swiper(".volunteer-swiper", {
  speed: 1000, // スライド変化時間
  slidesPerView: 1.1,
  loop: true,
  loopAdditionalSlides: 1,
  centeredSlides: true,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 1.5,
      spaceBetween: 16,
    },
  },
});

jQuery(function ($) {
  setTimeout(function () {
    $(".popup-overlay").show();
  }, 3000),
    $(".popup-close").click(function () {
      $(".popup-overlay").fadeOut();
    });
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".popup-inner").length) {
      $(".popup-overlay").fadeOut();
    }
  });
});

jQuery(function ($) {
  //swiper 768以下で起動
  var swiper;
  $(window).on("load resize", function () {
    var w = $(window).width();
    if (w <= 768) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper(".top-banner-swiper", {
          loop: true,
          slidesPerView: 1.1,
          loopAdditionalSlides: 1,
          centeredSlides: true,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            569: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});
